import { useState, useEffect } from 'react'
import useDebounce from '../../hooks/useDebounce'
import { Input } from '../../primitives'

import './index.scss'

/**
 * SearchBarWithDebounce Element
 * @param {Object} props
 * @param {String | String[]} [props.className] Extra Class Name at top level
 *
 * @param {Boolean} [props.isLoading=false] Search bar is disabled while loading
 * @param {Function} [props.onUpdateSearchText] The callback function triggered when the search text is updated
 * @param {String} [props.placeholderText=''] Prompt that displays in the search bar field
 *
 *  * @example
 * ```jsx
 *  <SearchBarWithDebounce
 *    isLoading={isLoading}
 *    onUpdateSearchText={onUpdateSearchText}
 *    placeholderText={I18n.get('Search by name')}
 *  />
 * ```
 */

const SearchBarWithDebounce = ({
  isLoading = false,
  onUpdateSearchText = () => {},
  placeholderText = ''
}) => {
  const [searchText, setSearchText] = useState('')
  const debounceSearchText = useDebounce(searchText, 500)

  useEffect(() => {
    onUpdateSearchText(debounceSearchText)
  }, [debounceSearchText, onUpdateSearchText])

  function onChangeText({ target: { value } }) {
    setSearchText(value)
  }

  return (
    <Input
      className='Searchbar'
      name='search'
      value={searchText}
      onChange={onChangeText}
      readOnly={isLoading}
      placeholder={placeholderText}
    />
  )
}

export default SearchBarWithDebounce
